var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 66,
    viewBox: "0 0 88 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_6372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5448 9.98151C19.0199 10.3218 19.1833 10.9529 18.9068 11.4679C16.2216 16.4665 13.0684 21.4502 10.0356 24.7083C11.8812 27.4315 14.0087 30.0974 16.377 32.2752C18.4063 34.1413 21.503 34.3831 23.842 32.6635C26.3107 30.8485 29.7098 28.0167 33.1755 24.0918C30.3088 20.9262 27.3679 16.1272 24.8434 11.4163C24.5486 10.8661 24.6689 10.1719 25.1533 9.77783C29.0376 6.61757 26.9218 0.409958 22.0638 0.10763C16.5867 -0.233027 14.1185 6.81179 18.5448 9.98151Z",
    fill: "#EE980D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4434 9.50791C63.0842 10.1141 63.2559 11.0632 62.8329 11.837C60.3744 16.3348 57.5423 20.9766 54.7766 24.0379C58.259 27.9913 61.6779 30.84 64.1582 32.6634C66.4894 34.3772 69.5871 34.1476 71.6234 32.2752C73.9745 30.1131 76.0882 27.47 77.9244 24.7675C74.9286 21.5579 71.8117 16.6424 69.1416 11.7339C68.7982 11.1027 68.9496 10.3025 69.5182 9.86334C73.5203 6.77286 71.4817 0.415373 66.5377 0.107545C63.3692 -0.0895957 60.7377 2.42167 60.7377 5.5479C60.7376 7.10784 61.3931 8.51447 62.4434 9.50791Z",
    fill: "#EE980D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.676034 12.0164C2.99257 16.7031 1.85458 20.5783 2.14608 36.958C2.14608 40.5638 2.14608 57.443 2.14608 61.542H85.8542C85.8542 48.3879 85.8542 31.8898 85.8542 19.0347C85.8542 15.9833 86.4245 14.0189 87.35 11.9564C88.7663 8.80266 87.6549 3.25231 84.7166 3.25231C82.206 3.25231 80.9496 7.35737 81.6223 10.5214C81.9361 11.9916 83.1563 13.8737 82.1261 16.8304C79.6682 21.5087 76.0637 27.3064 71.6233 31.3898C69.5933 33.2564 66.4964 33.4972 64.1581 31.7781C59.7371 28.5277 52.3326 22.0207 46.904 11.8021C46.5536 11.1421 46.7561 10.3363 47.3502 9.88324C51.4855 6.73071 49.258 0.0640247 44.0131 0.0968528C44.0088 0.0968528 44.0043 0.0966797 44 0.0966797C43.9956 0.0966797 43.9913 0.0968528 43.987 0.0968528C38.7393 0.0641965 36.4898 6.77351 40.6909 9.91453C41.2657 10.3442 41.4563 11.1228 41.1201 11.7569C35.6895 22.0015 28.2697 28.5231 23.8422 31.7782C21.5105 33.4922 18.413 33.262 16.3772 31.39C11.9368 27.3067 8.33221 21.5089 5.87439 16.8306C5.29878 15.1792 5.36547 13.3603 6.02496 11.7053C7.43691 8.16999 5.94177 3.25248 3.28389 3.25248C0.351018 3.25248 -0.862076 8.89754 0.676034 12.0164Z",
    fill: "url(#paint0_linear_91_6372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1894 48.8346C68.3931 48.8346 70.1795 47.0482 70.1795 44.8446C70.1795 42.6409 68.3931 40.8545 66.1894 40.8545C63.9858 40.8545 62.1993 42.6409 62.1993 44.8446C62.1993 47.0482 63.9858 48.8346 66.1894 48.8346Z",
    fill: "url(#paint1_linear_91_6372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1889 44.8446C65.4505 43.5655 65.5015 42.0482 66.1892 40.8545C65.5108 40.8538 64.8231 41.0252 64.1936 41.3887C62.2847 42.4906 61.6309 44.9314 62.7328 46.84C63.8349 48.7489 66.2755 49.4027 68.1841 48.3008C68.8139 47.9373 69.306 47.4275 69.6446 46.8395C68.2668 46.8381 66.9272 46.1237 66.1889 44.8446Z",
    fill: "#FFE2A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 52.1707C47.3583 52.1707 50.0807 48.924 50.0807 44.919C50.0807 40.914 47.3583 37.6672 44 37.6672C40.6416 37.6672 37.9192 40.914 37.9192 44.919C37.9192 48.924 40.6416 52.1707 44 52.1707Z",
    fill: "url(#paint2_linear_91_6372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0726 50.1038C44.7142 50.1038 41.9917 46.857 41.9917 42.8522C41.9917 40.8223 42.6919 38.9883 43.8191 37.6719C40.5447 37.7862 37.9189 40.9855 37.9189 44.918C37.9189 48.923 40.6414 52.1695 43.9999 52.1695C45.6561 52.1695 47.1569 51.3789 48.2535 50.0981C48.1935 50.1005 48.1335 50.1038 48.0726 50.1038Z",
    fill: "#FFE2A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6096 60.6567C76.2157 60.6567 11.6 60.6567 2.39044 60.6567C1.07027 60.6567 0 61.8315 0 63.2806C0 64.7295 1.07027 65.9044 2.39044 65.9044C11.7843 65.9044 76.4 65.9044 85.6096 65.9044C86.9299 65.9044 88 64.7298 88 63.2806C88 61.8313 86.9297 60.6567 85.6096 60.6567Z",
    fill: "#E39009"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3818 48.8346C23.5855 48.8346 25.3719 47.0482 25.3719 44.8446C25.3719 42.6409 23.5855 40.8545 21.3818 40.8545C19.1781 40.8545 17.3917 42.6409 17.3917 44.8446C17.3917 47.0482 19.1781 48.8346 21.3818 48.8346Z",
    fill: "url(#paint3_linear_91_6372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.381 44.8446C20.6426 43.5655 20.6937 42.0482 21.3813 40.8545C20.7029 40.8538 20.0153 41.0252 19.3857 41.3887C17.4768 42.4906 16.823 44.9314 17.9249 46.84C19.027 48.7489 21.4676 49.4027 23.3763 48.3008C24.006 47.9373 24.4981 47.4275 24.8367 46.8395C23.459 46.8381 22.1194 46.1237 21.381 44.8446Z",
    fill: "#FFE2A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_91_6372",
    x1: 43.9841,
    y1: 0.0966797,
    x2: 43.9841,
    y2: 61.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_91_6372",
    x1: 66.1894,
    y1: 48.8346,
    x2: 66.1894,
    y2: 40.8545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_91_6372",
    x1: 44,
    y1: 52.1707,
    x2: 44,
    y2: 37.6672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_91_6372",
    x1: 21.3818,
    y1: 48.8346,
    x2: 21.3818,
    y2: 40.8545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFD5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_6372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCrown);
export default __webpack_public_path__ + "static/media/icCrown.d4e1dbd5cfb5f7461481c8bd2a84f709.svg";
export { ForwardRef as ReactComponent };